import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { SingingPageService } from '../signing-page/signing-page-service';
import { GlobalService } from 'app/global/global.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-request-postponed',
  templateUrl: './request-postponed.component.html',
  styleUrl: './request-postponed.component.scss'
})
export class RequestPostponedComponent implements OnInit  {
  @Input() roleId: number;
  @Input() dueDate: string;
  public postponedForm!: FormGroup;
  public submitted = false;
  public loading: boolean = false;

  /**
   * constructor
   * @param fb 
   * @param _translocoService 
   * @param singingPage 
   * @param globalService 
   * @param activeModal 
   */
  constructor(
    private fb: FormBuilder, 
    private _translocoService: TranslocoService,
    private singingPage: SingingPageService,
    private globalService: GlobalService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.postponedForm = this.fb.group({
      message: [
        this._translocoService.translate('Request due date extension default message (Signing Page) - Please extend the due date of that document so I can review and sign it'),
        Validators.required
      ]
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.postponedForm.invalid) {
      return;
    }
    this.loading = true;
    this.singingPage.requestNewDueDate(Number(this.roleId), this.postponedForm.value.message).subscribe({
      next: () => {
        this.activeModal.close({success: true});
      },
      error: (err: string) => {
        this.loading = false;
        this.globalService.toastrError(err); 
      }
    });
  }

}
